var map = {
	"./abkhazia.svg": 3428,
	"./afghanistan.svg": 8862,
	"./aland-islands.svg": 7076,
	"./albania.svg": 8185,
	"./algeria.svg": 9223,
	"./american-samoa.svg": 965,
	"./andorra.svg": 1576,
	"./angola.svg": 6232,
	"./anguilla.svg": 9704,
	"./antigua-and-barbuda.svg": 4614,
	"./argentina.svg": 8096,
	"./armenia.svg": 9373,
	"./aruba.svg": 4207,
	"./australia.svg": 5832,
	"./austria.svg": 9530,
	"./azerbaijani-manat.svg": 8134,
	"./azores-islands.svg": 2366,
	"./bahamas.svg": 6283,
	"./bahrain.svg": 1843,
	"./balearic-islands.svg": 3286,
	"./bangladesh.svg": 4652,
	"./barbados.svg": 833,
	"./basque-country.svg": 104,
	"./belarus.svg": 4766,
	"./belgium.svg": 9888,
	"./belize.svg": 9813,
	"./benin.svg": 8657,
	"./bermuda.svg": 8689,
	"./bhutan-1.svg": 7900,
	"./bhutan.svg": 8046,
	"./bolivia.svg": 2254,
	"./bonaire.svg": 6379,
	"./bosnia-and-herzegovina.svg": 6851,
	"./botswana.svg": 1263,
	"./brazilian-real.svg": 5461,
	"./british-columbia.svg": 7715,
	"./british-indian-ocean-territory.svg": 9839,
	"./british-virgin-islands.svg": 1081,
	"./brunei.svg": 9935,
	"./bulgarian-lev.svg": 2922,
	"./burkina-faso.svg": 7444,
	"./burundian-franc.svg": 2908,
	"./cambodian-riel.svg": 7746,
	"./canada.svg": 5365,
	"./canary-islands.svg": 5038,
	"./cape-verde.svg": 5609,
	"./cayman-islands.svg": 9453,
	"./central-african-republic.svg": 66,
	"./ceuta.svg": 3848,
	"./cfa-franc-bceao.svg": 6735,
	"./cfa-franc-beac.svg": 6124,
	"./chad.svg": 7167,
	"./chilean-peso.svg": 8811,
	"./chinese-yuan.svg": 3117,
	"./christmas-island.svg": 7547,
	"./cocos-island.svg": 9638,
	"./colombian-peso.svg": 2758,
	"./comoros.svg": 9258,
	"./congolese-franc.svg": 8482,
	"./cook-islands.svg": 8802,
	"./corsica.svg": 6169,
	"./costa-rican-colón.svg": 876,
	"./croatian-kuna.svg": 2372,
	"./cuban-peso.svg": 1366,
	"./curacao.svg": 9794,
	"./cyprus.svg": 3014,
	"./czech-republic.svg": 8553,
	"./denmark.svg": 1570,
	"./djiboutian-franc.svg": 9010,
	"./dominica.svg": 4333,
	"./dominican-republic.svg": 7235,
	"./east-timor.svg": 7365,
	"./ecuador.svg": 7607,
	"./egyptian-pound.svg": 728,
	"./england.svg": 5671,
	"./equatorial-guinea.svg": 5077,
	"./eritrea.svg": 3726,
	"./estonia.svg": 1163,
	"./ethiopian-birr.svg": 5165,
	"./european-union.svg": 6064,
	"./falkland-islands.svg": 3453,
	"./faroe-islands.svg": 4227,
	"./fiji.svg": 8601,
	"./finland.svg": 3498,
	"./france.svg": 3273,
	"./french-polynesia.svg": 4734,
	"./gabon.svg": 6753,
	"./galapagos-islands.svg": 6926,
	"./gambian-dalasi.svg": 5203,
	"./georgian-lari.svg": 4382,
	"./germany.svg": 2956,
	"./ghanaian-cedi.svg": 7692,
	"./gibraltar.svg": 9493,
	"./greece.svg": 7414,
	"./greenland.svg": 8290,
	"./grenada.svg": 7370,
	"./guam.svg": 2938,
	"./guatemala.svg": 2749,
	"./guernsey.svg": 4973,
	"./guinea-bissau.svg": 4327,
	"./guinean-franc.svg": 57,
	"./guyana.svg": 7756,
	"./haiti.svg": 7139,
	"./hawaii.svg": 1637,
	"./honduras.svg": 3906,
	"./hong-kong-dollar.svg": 2410,
	"./hungary.svg": 2392,
	"./icelandic-króna.svg": 2672,
	"./indian-rupee.svg": 9961,
	"./indonesian-rupiah.svg": 4954,
	"./iranian-rial.svg": 7929,
	"./iraqi-dinar.svg": 8954,
	"./ireland.svg": 5095,
	"./isle-of-man.svg": 2837,
	"./israeli-new-sheqel.svg": 8309,
	"./italy.svg": 978,
	"./ivory-coast.svg": 4670,
	"./jamaica.svg": 3600,
	"./japanese-yen.svg": 1796,
	"./jersey.svg": 5794,
	"./jordanian-dinar.svg": 7398,
	"./kazakhstani-tenge.svg": 2390,
	"./kenyan-shilling.svg": 6276,
	"./kiribati.svg": 3089,
	"./kosovo.svg": 5497,
	"./kuwaiti-dinar.svg": 5298,
	"./kyrgystani-som.svg": 9282,
	"./laotian-kip.svg": 9343,
	"./latvia.svg": 9957,
	"./lebanese-pound.svg": 7796,
	"./lesotho.svg": 3019,
	"./liberia.svg": 3794,
	"./libyan-dinar.svg": 1973,
	"./liechtenstein.svg": 2210,
	"./lithuania.svg": 9355,
	"./luxembourg.svg": 1487,
	"./macao.svg": 373,
	"./macedonian-denar.svg": 1506,
	"./madeira.svg": 9341,
	"./malagasy-ariary.svg": 8940,
	"./malawian-kwacha.svg": 4430,
	"./malaysian-ringgit.svg": 4475,
	"./maldives.svg": 387,
	"./mali.svg": 3074,
	"./malta.svg": 8543,
	"./marshall-island.svg": 5032,
	"./martinique.svg": 770,
	"./mauritian-rupee.svg": 4530,
	"./mauritius.svg": 3184,
	"./melilla.svg": 5537,
	"./mexican-peso.svg": 8885,
	"./micronesia.svg": 7712,
	"./moldovan-leu.svg": 5443,
	"./monaco.svg": 33,
	"./mongolian-tugrik.svg": 5198,
	"./montenegro.svg": 7092,
	"./montserrat.svg": 1181,
	"./moroccan-dirham.svg": 2308,
	"./mozambican-metical.svg": 2137,
	"./myanmar.svg": 5187,
	"./namibian-dollar.svg": 3098,
	"./nato.svg": 4925,
	"./nauru.svg": 8282,
	"./nepalese-rupee.svg": 8958,
	"./netherlands.svg": 7420,
	"./new-taiwan-dollar.svg": 7672,
	"./new-zealand-dollar.svg": 4133,
	"./nicaraguan-córdoba.svg": 9784,
	"./nigerian-naira.svg": 4453,
	"./niue.svg": 777,
	"./norfolk-island.svg": 9182,
	"./north-korean-won.svg": 199,
	"./northen-cyprus.svg": 9012,
	"./northern-marianas-islands.svg": 6842,
	"./norwegian-krone.svg": 5733,
	"./omani-rial.svg": 1951,
	"./orkney-islands.svg": 4153,
	"./ossetia.svg": 6816,
	"./pakistani-rupee.svg": 3473,
	"./palau.svg": 7618,
	"./palestine.svg": 4496,
	"./panama.svg": 1938,
	"./papua-new-guinea.svg": 8910,
	"./paraguayan-guarani.svg": 2780,
	"./peruvian-nuevo-sol.svg": 8211,
	"./philippine-peso.svg": 4757,
	"./pitcairn-islands.svg": 3526,
	"./portugal.svg": 9157,
	"./puerto-rico.svg": 4335,
	"./qatari-rial.svg": 7428,
	"./rapa-nui.svg": 7822,
	"./republic-of-poland.svg": 9785,
	"./republic-of-the-congo.svg": 5682,
	"./romanian-leu.svg": 5608,
	"./russia.svg": 9225,
	"./rwanda.svg": 2474,
	"./saba-island.svg": 611,
	"./saint-kitts-and-nevis.svg": 2203,
	"./salvador.svg": 410,
	"./samoa.svg": 7804,
	"./san-marino.svg": 9370,
	"./sao-tome-and-principe.svg": 2937,
	"./sardinia.svg": 7726,
	"./saudi-riyal.svg": 3879,
	"./scotland.svg": 9140,
	"./senegal.svg": 7689,
	"./serbian-dinar.svg": 2704,
	"./seychellois-rupee.svg": 5701,
	"./sierra-leonean-leone.svg": 6310,
	"./singapore-dollar.svg": 5088,
	"./sint-eustatius.svg": 8075,
	"./sint-maarten.svg": 6780,
	"./slovakia.svg": 4601,
	"./slovenia.svg": 1290,
	"./solomon-islands.svg": 8033,
	"./somali-shilling.svg": 8580,
	"./somaliland.svg": 9137,
	"./south-african-rand.svg": 1945,
	"./south-korean-won.svg": 1498,
	"./south-sudan.svg": 5245,
	"./spain.svg": 4460,
	"./sri-lankan-rupee.svg": 1594,
	"./st-barts.svg": 9484,
	"./st-lucia.svg": 3079,
	"./st-vincent-and-the-grenadines.svg": 3217,
	"./sudanese-pound.svg": 9559,
	"./surinamese-dollar.svg": 756,
	"./swazi-lilangeni.svg": 7688,
	"./swedish-krona.svg": 2795,
	"./switzerland.svg": 527,
	"./syrian-pound.svg": 7915,
	"./tajikistani-somoni.svg": 7468,
	"./tanzanian-shilling.svg": 8074,
	"./thai-baht.svg": 1137,
	"./tibet.svg": 3455,
	"./togo.svg": 2726,
	"./tokelau.svg": 3530,
	"./tonga.svg": 2737,
	"./transnistria.svg": 4572,
	"./trinidad-and-tobago.svg": 4,
	"./tunisian-dinar.svg": 4110,
	"./turkey.svg": 7233,
	"./turkmenistan.svg": 4254,
	"./turks-and-caicos.svg": 8209,
	"./tuvalu.svg": 4542,
	"./uganda.svg": 1132,
	"./ukraine.svg": 8138,
	"./united-arab-emirates-dirham.svg": 6576,
	"./united-kingdom.svg": 5179,
	"./united-nations.svg": 4502,
	"./uruguay.svg": 2504,
	"./usa.svg": 7067,
	"./uzbekistan.svg": 1636,
	"./vanuatu.svg": 1051,
	"./vatican-city.svg": 5106,
	"./venezuela.svg": 366,
	"./vietnamese-dong.svg": 7608,
	"./virgin-islands.svg": 8148,
	"./wales.svg": 8715,
	"./western-sahara.svg": 1757,
	"./yemeni-rial.svg": 8675,
	"./zambia.svg": 9385,
	"./zimbabwe.svg": 6125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 236;